import axios from 'axios';
import {Message} from 'element-ui';
import store from '../store';
// import router from '../router';
import initEnv from '@/utils/initEnv';
import router from '@/router';
import Cookies from 'js-cookie';

export function getAxiosService(serviceConfig = {}) {
    serviceConfig = Object.assign({}, {
        baseURL: global.BasePath,
        timeout: 10000,
        signApiList: [],
        withoutTokenList: []
    }, serviceConfig);

    const signApiList = [];
    const withoutTokenList = [
        'login/fromOldFramework',
        'common/voteTwo/getVoteByRecruitUser',
        'common/voteTwo/addVoteTwoRecruitUserSelectedList',
        'getStuInfoByToken',
        'insertStuInfo',
        'updateStuInfo',
        'common/staterunEnrolStudent/additionalStuInfo'
    ];
    serviceConfig.signApiList = [...serviceConfig.signApiList, ...signApiList];
    serviceConfig.withoutTokenList = [...serviceConfig.withoutTokenList, ...withoutTokenList];

    // 创建axios实例
    const service = axios.create({
        baseURL: serviceConfig.baseURL, // api的base_url
        timeout: serviceConfig.timeout // 请求超时时间
    });

// request拦截器
    service.interceptors.request.use(config => {
        if (!config.params) {
            config.params = new URLSearchParams();
        }
        const signApiArray = serviceConfig.signApiList;
        const withoutTokenArray = serviceConfig.withoutTokenList;
        if (!config.params.has('token') && withoutTokenArray.every(item => config.url.indexOf(item) === -1)) {
            config.params.append('token', Cookies.get('Admin-Token'));
        }

        if (signApiArray.some(item => config.url.indexOf(item) !== -1)) {
            if (!config.params.has('sign')) {
                const sign = window.sessionStorage.sign ? window.sessionStorage.sign : '';
                config.params.append('sign', sign);
            }
        }
        if(serviceConfig.isArchive && !config.params.has('schoolYear')) {
            config.params.append('schoolYear', store.getters.selectedSchoolYear);
        }
        return config;
    }, error => {
        Promise.reject(error);
    });

// respone拦截器
    service.interceptors.response.use(
        response => {
            const code = response.data.code;
            // code = 200; // 成功
            // code = 400; // 访问被禁止
            // code = 403; // 访问被禁止
            // code = 404; // 资源不存在
            // code = 500; // 内部服务器错误
            // code = 1000; // 登录超时
            // code = 1001; // 不合法的参数
            // code = 1002; // 不合法的请求格式
            // code = 1003; // 不合法的请求格式
            // code = 1004; // 需要HTTPS
            // code = 1050; // 账号或密码错误
            // code = 1051; // 该用户已被禁用
            // code = 1053; // 学校异常，请联系学校管理员
            // code = 1054; // 身份不允许登录
            // code = 1056; // 该账号不存在
            const blockedCode = [-1, 400, 403, 404, 500, 1000, 1001, 1002, 1003, 1004, 1050, 1051, 1053, 1054, 1056];
            if (blockedCode.indexOf(code) !== -1) {
                Message({
                    message: response.data.msg,
                    type: 'error',
                    duration: 5 * 1000
                });
                // if (code === 1000) {
                //     store.dispatch('FedLogOut').then(res => {
                //         router.push({path: '/login'});
                //     }).catch();
                // }
                return Promise.reject({code: response.data.code, mes: response.data.msg});
            } else {
                return response;
            }
        },
        error => {
            Message({
                message: error.message,
                type: 'error',
                duration: 5 * 1000
            });
            return Promise.reject(error);
        }
    );
    return service;
}

const fetch = getAxiosService();

export default fetch;

export const archivedFetch = getAxiosService({
    baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/module-web/' : 'https://www.weixiaojia.net/module-web/',
    isArchive: true
})

// 归档
export const autoFetch = function (args) {
    if(args.url.includes('voteTwo/')) {
        return archivedFetch(args);
    } else {
        return fetch(args);
    }
}

export const systemFetch = getAxiosService({
    baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/ucenter-web/' : 'https://www.weixiaojia.net/ucenter-web/'
});



// WEBPACK FOOTER //
// ./src/utils/fetch.js